
import moment from 'moment'
export default date => {
    const keys = new Array(31).fill(1).reduce((a, b, i) => ({ ...a, [`m${i + 1}`]: 0 }), {});
    return [
        {
            name: "Pickup总计",
            type: "Room Nights",
            total: 0,
            otb: 0,
            msc: 0,
            sort: 0,
            ...keys
        }, {
            name: "Pickup总计",
            type: "Room Revenue",
            total: 0,
            otb: 0,
            msc: 0,
            sort: 1,
            ...keys
        }, {
            name: moment(date).format("YYYY年MM月"),
            type: "Room Nights",
            total: 0,
            otb: 0,
            msc: 0,
            sort: 2,
            ...keys
        }, {
            name: moment(date).format("YYYY年MM月"),
            type: "Room Revenue",
            total: 0,
            otb: 0,
            msc: 0,
            sort: 3,
            ...keys
        }, {
            name: moment(date).add(1, 'month').format("YYYY年MM月"),
            type: "Room Nights",
            total: 0,
            otb: 0,
            msc: 0,
            sort: 4,
            ...keys
        }, {
            name: moment(date).add(1, 'month').format("YYYY年MM月"),
            type: "Room Revenue",
            total: 0,
            otb: 0,
            msc: 0,
            sort: 5,
            ...keys
        }, {
            name: moment(date).add(2, 'month').format("YYYY年MM月"),
            type: "Room Nights",
            total: 0,
            otb: 0,
            msc: 0,
            sort: 6,
            ...keys
        }, {
            name: moment(date).add(2, 'month').format("YYYY年MM月"),
            type: "Room Revenue",
            total: 0,
            otb: 0,
            msc: 0,
            sort: 7,
            ...keys
        }
    ]
}



// WEBPACK FOOTER //
// ./src/components/table/4.0/4-2/4.2.5/data.js